import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHourglassBottom = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 11L8.995 8L7 6L8.995 3.995L9 1H3V4L5 6L3 7.995V11H9ZM4 3.75V2H8V3.75L6 5.75L4 3.75Z",
		fill: "currentColor"
	})
});
export default SvgIconHourglassBottom;
